// @ts-nocheck
import { ADJUSTMENT_TYPES } from "../../../appCalcutions";
import { apiRequest } from "../../../services/apiService";
import {
  ADD_NON_TAXABLE_FAILURE,
  ADD_NON_TAXABLE_REQUEST,
  ADD_NON_TAXABLE_SUCCESS,
  ADD_REIMBURSEMENT_AND_DEDUCTION_CATEGORY_FAILURE,
  ADD_REIMBURSEMENT_AND_DEDUCTION_CATEGORY_REQUEST,
  ADD_REIMBURSEMENT_AND_DEDUCTION_CATEGORY_SUCCESS,
  ADD_REIMBURSEMENT_CONT_FAILURE,
  ADD_REIMBURSEMENT_CONT_REQUEST,
  ADD_REIMBURSEMENT_CONT_SUCCESS,
  ADD_REIMBURSEMENT_FAILURE,
  ADD_REIMBURSEMENT_REQUEST,
  ADD_REIMBURSEMENT_SUCCESS,
  CLOSE_DEDUCTION_MODAL,
  CLOSE_NON_TAXABLE_MODAL,
  CLOSE_REIMBURSEMENT_MODAL,
  GET_ALL_REIM_AND_DEDUC_OF_EVENT_FAILURE,
  GET_ALL_REIM_AND_DEDUC_OF_EVENT_REQUEST,
  GET_ALL_REIM_AND_DEDUC_OF_EVENT_SUCCESS,
  GET_DEDUCTION_CATEGORY_FAILURE,
  GET_DEDUCTION_CATEGORY_REQUEST,
  GET_DEDUCTION_CATEGORY_SUCCESS,
  GET_NON_TAXABLE_CATEGORY_FAILURE,
  GET_NON_TAXABLE_CATEGORY_REQUEST,
  GET_NON_TAXABLE_CATEGORY_SUCCESS,
  GET_REIMBURSEMENT_CATEGORY_FAILURE,
  GET_REIMBURSEMENT_CATEGORY_REQUEST,
  GET_REIMBURSEMENT_CATEGORY_SUCCESS,
  OPEN_DEDUCTION_MODAL,
  OPEN_NON_TAXABLE_MODAL,
  OPEN_REIMBURSEMENT_MODAL,
  REMOVE_REIMBURSEMENT_AND_DEDUCTION_CATEGORY_FAILURE,
  REMOVE_REIMBURSEMENT_AND_DEDUCTION_CATEGORY_REQUEST,
  REMOVE_REIMBURSEMENT_AND_DEDUCTION_CATEGORY_SUCCESS,
  REMOVE_REIMBURSEMENT_OR_DEDUCTION_FAILURE,
  REMOVE_REIMBURSEMENT_OR_DEDUCTION_REQUEST,
  REMOVE_REIMBURSEMENT_OR_DEDUCTION_SUCCESS,
  UPDATE_REIMB_AND_DEDUCT_FAILURE,
  UPDATE_REIMB_AND_DEDUCT_REQUEST,
  UPDATE_REIMB_AND_DEDUCT_SUCCESS,
} from "../../constants/event/adjustments";
import { alertDialogAciton } from "../auth";
import { updatePOUpdateNeededAction } from "../eventRequestDetails";

/**
 * add reimbursement and deduction categories
 *
 * @example 
 * http://localhost:8000/api/v4/addReimbursementCategory?Id=68e7f87eb2af9b50412337a7
 * {
    "type":"deduction" | "reimbursement",
    "deductionCategoryType":"Other",
    "deductionFromClientInvoice":true
}
 */
export const addReimbursementAndDeductionCategoryAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: ADD_REIMBURSEMENT_AND_DEDUCTION_CATEGORY_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: "addReimbursementCategory",
      params: payload?.params,
      data: payload?.data,
      isToken: true,
    });
    if (response?.status == 200) {
      dispatch({ type: ADD_REIMBURSEMENT_AND_DEDUCTION_CATEGORY_SUCCESS });
      successCallback?.(response?.data?.message);
    } else if (response?.status != 200 || error) {
      dispatch({ type: ADD_REIMBURSEMENT_AND_DEDUCTION_CATEGORY_FAILURE });
      failureCallback?.(error?.response?.data?.message);
    }
  };
};

/**
 * get reimbursement categories
 *
 * @example
 * http://localhost:8000/api/v4/getReimbursementDeductionCategories?type=deduction
 */
export const getReimbursementCategoriesAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: GET_REIMBURSEMENT_CATEGORY_REQUEST });
    const { response, error } = await apiRequest({
      method: "GET",
      url: "getReimbursementDeductionCategories",
      params: {
        type: "reimbursement",
      },
      data: payload?.data,
      isToken: true,
    });
    if (response?.status == 200) {
      dispatch({
        type: GET_REIMBURSEMENT_CATEGORY_SUCCESS,
        payload: response?.data?.data,
      });
      successCallback?.(response?.data?.message);
    } else if (response?.status != 200 || error) {
      dispatch({ type: GET_REIMBURSEMENT_CATEGORY_FAILURE });
      failureCallback?.(error?.response?.data?.message);
    }
  };
};

/**
 * get deduction categories
 *
 * @example
 * http://localhost:8000/api/v4/getReimbursementDeductionCategories?type=deduction
 */
export const getDeductionCategoriesAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: GET_DEDUCTION_CATEGORY_REQUEST });
    const { response, error } = await apiRequest({
      method: "GET",
      url: "getReimbursementDeductionCategories",
      params: {
        type: "deduction",
      },
      data: payload?.data,
      isToken: true,
    });
    if (response?.status == 200) {
      dispatch({
        type: GET_DEDUCTION_CATEGORY_SUCCESS,
        payload: response?.data?.data,
      });
      successCallback?.(response?.data?.message);
    } else if (response?.status != 200 || error) {
      dispatch({ type: GET_DEDUCTION_CATEGORY_FAILURE });
      failureCallback?.(error?.response?.data?.message);
    }
  };
};

/**
 * get non taxable categories
 *
 * @example
 * http://localhost:8000/api/v4/getReimbursementDeductionCategories?type=deduction
 */
export const getNonTaxableCategoriesAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: GET_NON_TAXABLE_CATEGORY_REQUEST });
    const { response, error } = await apiRequest({
      method: "GET",
      url: "getReimbursementDeductionCategories",
      params: {
        type: ADJUSTMENT_TYPES.NON_TAXABLE_CHARGES,
      },
      data: payload?.data,
      isToken: true,
    });
    if (response?.status == 200) {
      dispatch({
        type: GET_NON_TAXABLE_CATEGORY_SUCCESS,
        payload: response?.data?.data,
      });
      successCallback?.(response?.data?.message);
    } else if (response?.status != 200 || error) {
      dispatch({ type: GET_NON_TAXABLE_CATEGORY_FAILURE });
      failureCallback?.(error?.response?.data?.message);
    }
  };
};

/**
 * delete reimbursement or deduction categories
 *
 * @example
 * http://localhost:8000/api/v4/deleteReimbursementDeductionCategory?id=68e8011982b0d9bb5197e643
 */
export const removeReimbursementAndDeductionCategoriesAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: REMOVE_REIMBURSEMENT_AND_DEDUCTION_CATEGORY_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: "deleteReimbursementDeductionCategory",
      params: payload?.params,
      data: payload?.data,
      isToken: true,
    });
    if (response?.status == 200) {
      dispatch({
        type: REMOVE_REIMBURSEMENT_AND_DEDUCTION_CATEGORY_SUCCESS,
        payload: response?.data?.data,
      });
      successCallback?.(response?.data?.message);
    } else if (response?.status != 200 || error) {
      dispatch({ type: REMOVE_REIMBURSEMENT_AND_DEDUCTION_CATEGORY_FAILURE });
      failureCallback?.(error?.response?.data?.message);
    }
  };
};

/**
 * get all reimbursement of event
 */
let adjustmentRequestSequence = 0;
export const getAllAdjustmentOfEventAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    const meta = { eventId: String(payload?.params?.eventId || ""), requestId: ++adjustmentRequestSequence };
    dispatch({ type: GET_ALL_REIM_AND_DEDUC_OF_EVENT_REQUEST, meta });
    const { response, error } = await apiRequest({
      method: "GET",
      url: "getReimbursementDeductionsForEvent",
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });

    if (response?.status == 200) {
      dispatch({
        type: GET_ALL_REIM_AND_DEDUC_OF_EVENT_SUCCESS,
        payload: response?.data,
        meta,
      });
      successCallback?.(response?.data?.message);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: GET_ALL_REIM_AND_DEDUC_OF_EVENT_FAILURE, meta, error: error?.response?.data?.message || "Unable to refresh show expenses" });
      failureCallback?.(error?.response?.data?.message);
    }
  };
};

/**
 * remove reimbursement or deduction
 *
 * @example
 * http://localhost:8000/api/v4/deleteReimbursementDeduction
 * {
    "ids":[
        {
            "id":"68e7f87eb2af9b50412337a7"
        }
    ]
}
 */
export const removeReimbursementOrDeductionAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: REMOVE_REIMBURSEMENT_OR_DEDUCTION_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: "deleteReimbursementDeduction",
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });

    if (response?.status == 200) {
      dispatch({
        type: REMOVE_REIMBURSEMENT_OR_DEDUCTION_SUCCESS,
        payload: response?.data?.data,
      });
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Success",
          message: response?.data?.message || "Item Deleted Successfully.",
        }),
      );
      dispatch(
        updatePOUpdateNeededAction({
          payload: { contractorId: payload?.additionalData?.contractorId },
        }),
      );
      // Refetch the event's reim/deduc/non-taxable list so the
      // accordion updates (the UI reads from `eventAdjustments.nonTaxableCharges`,
      // and the REMOVE_*_SUCCESS reducer only sets loading=false — it does not
      // remove the item from the list). Without this, the deleted item stays
      // visible with the "Applied" badge until the user reloads the page.
      const eventId =
        payload?.params?.eventId || payload?.additionalData?.eventId;
      if (eventId) {
        dispatch(
          getAllAdjustmentOfEventAction({
            payload: { params: { eventId } },
          }),
        );
      }
      successCallback?.(response?.data?.message);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: REMOVE_REIMBURSEMENT_OR_DEDUCTION_FAILURE });
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Error",
          message: error?.response?.data?.message || "Failed to delete item.",
        }),
      );
      failureCallback?.(error?.response?.data?.message);
    }
  };
};

/**
 * add new reimbursement by admin
 */
export const addReimbursementByAdminAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: ADD_REIMBURSEMENT_REQUEST });
    const { error, response } = await apiRequest({
      method: "PUT",
      url: `reimbursementAddedByAdmin`,
      params: payload?.params,
      data: payload?.formData,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: ADD_REIMBURSEMENT_SUCCESS,
        payload: {
          newData: response?.data?.positionDataToUpdate,
          id: payload?.params?.id,
          sessionId: payload?.params?.sessionId,
        },
      });
      dispatch(
        updatePOUpdateNeededAction({
          payload: { contractorId: payload?.params?.contractorId },
        }),
      );
      if (successCallback) successCallback(response?.data?.message);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: ADD_REIMBURSEMENT_FAILURE });
      if (failureCallback) failureCallback(error?.response?.data?.message);
    }
  };
};

/**
 * add new non taxable by admin
 *
 * @example
 * http://localhost:8000/api/v4/reimbursementAddedByContractor?eventId=68dd1ec1b63bea33e2d26083
 */
export const addNonTaxableChargeByAdminAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: ADD_NON_TAXABLE_REQUEST });
    const { error, response } = await apiRequest({
      method: "PUT",
      url: `nonTaxableChargesAddedByAdmin`,
      params: payload?.params,
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: ADD_NON_TAXABLE_SUCCESS,
        payload: {
          newData: response?.data?.positionDataToUpdate,
          id: payload?.params?.id,
          sessionId: payload?.params?.sessionId,
        },
      });
      if (successCallback)
        successCallback(response?.data?.message, response?.data);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: ADD_NON_TAXABLE_FAILURE });
      if (failureCallback) failureCallback(error?.response?.data?.message);
    }
  };
};

/**
 * add new reimbursement by contractor
 *
 * @example
 * http://localhost:8000/api/v4/reimbursementAddedByContractor?eventId=68dd1ec1b63bea33e2d26083
 */
export const addReimbursementByContractorAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: ADD_REIMBURSEMENT_CONT_REQUEST });
    const { error, response } = await apiRequest({
      method: "PUT",
      url: `reimbursementAddedByContractor`,
      params: payload?.params,
      data: payload?.formData,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: ADD_REIMBURSEMENT_CONT_SUCCESS,
        payload: {
          newData: response?.data?.positionDataToUpdate,
          id: payload?.params?.id,
          sessionId: payload?.params?.sessionId,
        },
      });
      if (successCallback)
        successCallback(response?.data?.message, response?.data);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: ADD_REIMBURSEMENT_CONT_FAILURE });
      if (failureCallback) failureCallback();
    }
  };
};

/**
 * update reimbursement
 *
 * @example
 * http://localhost:8000/api/v4/updateReimbursementDeduction?eventId=68dd1ec1b63bea33e2d26083&reimbursementDeductionId=68ed4e6fadd447beedd0e947
 */
export const updateReimbursementAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_REIMB_AND_DEDUCT_REQUEST });
    const { error, response } = await apiRequest({
      method: "PUT",
      url: `updateReimbursementDeduction`,
      params: payload?.params,
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: UPDATE_REIMB_AND_DEDUCT_SUCCESS,
        payload: {
          newData: response?.data?.positionDataToUpdate,
          id: payload?.params?.id,
          sessionId: payload?.params?.sessionId,
        },
      });
      dispatch(
        updatePOUpdateNeededAction({
          payload: { contractorId: payload?.additionalData?.contractorId },
        }),
      );
      if (successCallback) successCallback(response?.data?.message);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: UPDATE_REIMB_AND_DEDUCT_FAILURE });
      if (failureCallback) failureCallback();
    }
  };
};

/**
 * open reimbursement modal
 */
export const openReimbursementModalAction = ({ payload }) => {
  return (dispatch) => {
    // if (!payload?.contractorDetails?._id) {
    //   dispatch(
    //     alertDialogAciton({
    //       open: true,
    //       title: "Error",
    //       message: "Contractor hasn't been assigned to this position.",
    //     }),
    //   );
    //
    //   return;
    // }
    dispatch({ type: OPEN_REIMBURSEMENT_MODAL, payload });
  };
};

/**
 * close reimbursement modal
 */
export const closeReimbursementModalAction = () => {
  return { type: CLOSE_REIMBURSEMENT_MODAL };
};

/**
 * open deduction modal
 */
export const openDeductionModalAction = ({ payload }) => {
  return (dispatch) => {
    // if (!payload?.contractorDetails?._id) {
    //   dispatch(
    //     alertDialogAciton({
    //       open: true,
    //       title: "Error",
    //       message: "Contractor hasn't been assigned to this position.",
    //     }),
    //   );
    //
    //   return;
    // }
    dispatch({ type: OPEN_DEDUCTION_MODAL, payload });
  };
};

/**
 * close deduction modal
 */
export const closeDeductionModalAction = () => {
  return { type: CLOSE_DEDUCTION_MODAL };
};

/**
 * open non taxable charges modal
 */
export const openNonTaxableModalAction = ({ payload }) => {
  return (dispatch) => {
    dispatch({ type: OPEN_NON_TAXABLE_MODAL, payload });
  };
};

/**
 * close non taxable charges modal
 */
export const closeNonTaxableModalAction = () => {
  return { type: CLOSE_NON_TAXABLE_MODAL };
};